import React, { useState, useEffect } from "react";
import PostCardSideBar from "./BlogsCardSideBar";
import { useBlogContext } from "../../shared/context/BlogContext";
import { useTranslation } from "react-i18next";
import "./magazine.css";
import { currentLang } from "../../shared/seo/links";

export default function BlogsSideBar() {
  const Lng = currentLang();
  const { t } = useTranslation();
  const [blogs, setBlogs] = useState([]);
  const { getBlogsByFilter } = useBlogContext();
  useEffect(() => {
    let live = true;
    async function fetchBlogs() {
      const response = await getBlogsByFilter({
        limit: 4,
        filters: [{ language: Lng, status: "published" }],
      });
      // The page may have changed (an article's related link) meanwhile.
      if (live) setBlogs(response.data?.blogs ?? []);
    }
    fetchBlogs();
    return () => {
      live = false;
    };
  }, [getBlogsByFilter]);
  return (
    <div className="avc-sidebar-card">
      <h4 className="avc-sidebar-card__title">{t("Latest_Posts")}</h4>
      <ul className="avc-latest">
        {blogs?.length > 0 &&
          blogs.map((blog) => <PostCardSideBar key={blog.id} blog={blog} />)}
      </ul>
    </div>
  );
}
